import React from 'react';
import { Outlet } from 'react-router-dom';
import LoginLeft from '../login/loginLeft';
import InfoPanel from '../../../common/infoPanel';

const AuthLayout = ({leftPanel}) => {
  const LeftPanelComponent = leftPanel === 'info' ? InfoPanel : LoginLeft;
  return (
    <div className="flex bg-white h-full">
      <LeftPanelComponent />
      <div className="flex flex-col justify-center items-center w-full xl:w-1/2 2xl:w-1/2 lg:w-1/2 scale-[0.9] 2xl:scale-100 xl:scale-100 lg:scale-100 transition">
        <Outlet />
      </div>
    </div>
  );
};

export default AuthLayout; 